import React from 'react'
import { useTranslation } from 'react-i18next'

interface Links {
  link: string
  events: number
}

interface Props {
  data: Links[]
}

export default function TopLinks({ data }: Props) {
  const { t } = useTranslation()
  return (
    <div className="mb-10">
      <h3 className="mb-4 text-xl font-bold">{t('Top Performing Links')}</h3>
      <p className="w-full text-right text-sm">{t('Clicks')}</p>
      {data.map((link, index) => (
        <div key={index} className="mb-4 flex justify-between border-b pb-2">
          <div>{link.link}</div>
          <div className="font-bold">{link.events}</div>
        </div>
      ))}
    </div>
  )
}
